import { render } from "./PreferredSkillsDialog.vue?vue&type=template&id=5620267a&scoped=true"
import script from "./PreferredSkillsDialog.vue?vue&type=script&lang=js"
export * from "./PreferredSkillsDialog.vue?vue&type=script&lang=js"

import "./PreferredSkillsDialog.vue?vue&type=style&index=0&id=5620267a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5620267a"]])

export default __exports__